import { PROFILE_SHOW_SELECTOR, PROFILE_HIDE_SELECTOR } from '../constants'

export function actionProfileShowSelector(server, user, boundingRectangle, title) {
    return {
        type: PROFILE_SHOW_SELECTOR,
        payload: { server, user, boundingRectangle, title },
    }
}

export function actionProfileHideSelector() {
    return {
        type: PROFILE_HIDE_SELECTOR,
    }
}



// WEBPACK FOOTER //
// ./src/actions/profile.js